/*
 * @Description: 增值服务
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const vipManagement: Array<RouteRecordRaw> = [
	{
		path: '/vipManagement',
		component: Layout,
		redirect: '/vipManagement/valueAddedServices',
		children: [
			{
				path: 'valueAddedServices',
				component: () => import(/* webpackChunkName: "valueAddedServices" */ '@/views/vipManagement/valueAddedServices/services.vue'),
				name: 'valueAddedServices',
				meta: { title: '增值服务' },

			},
            {
                path: 'valueAddedServicesInfo',
                component: () => import(/* webpackChunkName: "valueAddedServicesInfo" */ '@/views/vipManagement/valueAddedServices/servicesInfo.vue'),
                name: 'valueAddedServicesInfo',
                meta: { title: '增值服务详情' }
            }
		]
	}
]

export default vipManagement
